import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DeleteAccountWidget } from "./components/delete-account/delete-account-widget";

function DeleteAccountRenderer() {
  const rootElement = document.getElementById(
    "delete-account__submit-button-wrapper"
  );
  if (!rootElement) return;

  createRoot(rootElement).render(
    <StrictMode>
      <DeleteAccountWidget
        popupButton={rootElement.dataset.popupButton}
        popupTitle={rootElement.dataset.popupTitle}
        popupText={rootElement.dataset.popupText}
        popupSubmit={rootElement.dataset.popupSubmit}
        popupCancel={rootElement.dataset.popupCancel}
      />
    </StrictMode>
  );
}

export const initDeleteAccount = () => {
  if (document.readyState !== "loading") {
    DeleteAccountRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", DeleteAccountRenderer);
  }
};
